import { render, staticRenderFns } from "./DialogExport.vue?vue&type=template&id=10e09924&scoped=true&"
import script from "./DialogExport.vue?vue&type=script&lang=js&"
export * from "./DialogExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/lucianocolucci/Desktop/Share Windows/IngeniAR/WebProject/Syscore-mods/Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e09924",
  null
  
)

export default component.exports